export const CRM_MESSENGER_READ_EVENT = 'crm-messenger-read';

export function dispatchCrmMessengerRead(detail) {
  window.dispatchEvent(new CustomEvent(CRM_MESSENGER_READ_EVENT, {detail}));
}
